import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Paper,
  Typography,
  Button,
  Divider,
  Chip,
  Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

export default function ResultsPage() {
  const { state } = useLocation();
  const navigate = useNavigate();

  const score = state?.score ?? 0;
  const total = state?.total ?? 0;
  const results = Array.isArray(state?.results) ? state.results : [];

  const pct = total ? Math.round((score / total) * 100) : 0;

  return (
    <Box
      sx={{
        direction: "ltr",
        minHeight: "75dvh",
        backgroundImage: "url('/bg-badook.png')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
        py: 4,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 3,
          maxWidth: 900,
          width: "100%",
          bgcolor: "rgba(255,255,255,0.95)",
          borderRadius: 3,
          textAlign: "left",
        }}
      >
        {/* כותרת ותוצאה */}
        <Typography variant="h5" gutterBottom>
          סיכום המבחן
        </Typography>

        <Typography variant="subtitle1" sx={{ mb: 1 }}>
          ניקוד: {score} מתוך {total} ({pct}%)
        </Typography>

        <Divider sx={{ my: 2 }} />

        {/* פירוט שאלות */}
        <Stack spacing={2}>
          {results.map((r, idx) => {
            const wasCorrect = r.correct;
            const color = wasCorrect ? "success" : "error";
            const Icon = wasCorrect ? CheckCircleIcon : CancelIcon;

            return (
              <Paper
                key={`${r.id}-${idx}`}
                variant="outlined"
                sx={{ p: 2, borderRadius: 2 }}
              >
                <Stack
                  direction="row"
                  spacing={1}
                  alignItems="center"
                  sx={{ mb: 1 }}
                >
                  <Chip
                    color={color}
                    icon={<Icon />}
                    label={wasCorrect ? "נכון" : "לא נכון"}
                    size="small"
                  />
                  <Typography variant="overline" sx={{ opacity: 0.8 }}>
                    שאלה {idx + 1}
                  </Typography>
                </Stack>

                <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  {r.text}
                </Typography>

                {/* תשובת המשתמש + התשובה הנכונה */}
                <Typography variant="body2" sx={{ mb: 0.5 }}>
                  <strong>התשובה שלך:</strong>{" "}
                  {r.selectedKey ? r.answers?.[r.selectedKey] : "לא נבחרה תשובה"}
                </Typography>
                <Typography variant="body2" sx={{ mb: 1 }}>
                  <strong>התשובה הנכונה:</strong> {r.answers?.[r.correctKey]}
                </Typography>

                {!!r.explanation && (
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, opacity: 0.9, whiteSpace: "pre-wrap" }}
                  >
                    <strong>הסבר: </strong>
                    {r.explanation}
                  </Typography>
                )}
              </Paper>
            );
          })}
        </Stack>

        {/* כפתורים */}
        <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
          <Button color="inherit" onClick={() => navigate("/")}>
            חזרה למסך הבית
          </Button>
          <Box>
            <Button
              sx={{ mr: 1 }}
              variant="outlined"
              onClick={() => navigate(-1)}
            >
              חזרה לשאלה אחרונה
            </Button>
           
          </Box>
        </Box>
      </Paper>
    </Box>
  );
}
